import type { FamilyHistoryRecord } from '@liza/fhir-utils';
import { useTranslation } from 'react-i18next';
import { type FamilyHistoryItemProps, recordDescription, recordTitle } from './familyHistoryRows';
import { RecordListItem } from './RecordListItem';

export type FamilyMemberRecordItemProps = FamilyHistoryItemProps & { record: FamilyHistoryRecord };

/** One source resource as a selectable, promotable row under the relationship it was recorded with. */
export const FamilyMemberRecordItem = ({
  record,
  onSelectFamilyMember,
  selectedFamilyMemberId,
  onPromotionClick,
  getPromotionStatus,
}: FamilyMemberRecordItemProps): React.ReactElement => {
  const { t } = useTranslation('records');
  return (
    <RecordListItem
      testId="family-member-item"
      title={recordTitle(record, t)}
      description={recordDescription(record, t)}
      onClick={onSelectFamilyMember ? (): void => onSelectFamilyMember(record.id) : undefined}
      selected={selectedFamilyMemberId === record.id}
      onPromotionClick={onPromotionClick ? (): void => onPromotionClick(record.id) : undefined}
      promotionStatus={getPromotionStatus?.(record.id)}
    />
  );
};
